import { IS_PRODUCT } from '@/constants';

//* 테스트 기간이라 dev·stage에선 웹에서도 신청을 연다 — 운영은 앱 전용 유지
export const IS_WEB_APPLY_ALLOWED = !IS_PRODUCT;
